import { render } from "./TaskEmailSettings.vue?vue&type=template&id=b5e76fb0"
import script from "./TaskEmailSettings.vue?vue&type=script&lang=js"
export * from "./TaskEmailSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__